
import heic2any from "heic2any";

export const convertHeic = async (file: File) => {
    if (file.type === "image/heic" || file.name.match(/\.(heic|heif)$/i)) {
        const blob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.9
        });

        return new File(
            [blob as Blob],
            file.name.replace(/\.(heic|heif)$/i, ".jpg"),
            { type: "image/jpeg" }
        );
    }

    return file;
};

export const compressImage = async (file: File, quality = 1): Promise<File> => {
  if (!file.type.includes("image") || file.type.includes("gif")) return file;

  return new Promise<File>((resolve) => {
    const img = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const url = URL.createObjectURL(file);
    img.src = url;

    img.onload = () => {
      URL.revokeObjectURL(url);

      const maxWidth = 600;
      const scale = Math.min(1, maxWidth / img.width);

      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      if (!ctx) {
        resolve(file);
        return;
      }

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(file);
            return;
          }

          const newName = file.name.replace(/\.\w+$/, ".jpg");

          resolve(
            new File([blob], newName, {
              type: "image/jpeg",
            })
          );
        },
        "image/jpeg",
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };
  });
};